import { getMimeType } from './get-mime-type'
import { getFileContents } from './get-file-contents'

export const getUploadableFile = async (file) => {
  return {
    name: file.name,
    mimeType: file.type || getMimeType(file.name),
    content: await getFileContents(file),
  }
}